
const ADMIN = 'ADMIN';
const AGENCY_GROUP = 'AGENCY_GROUP';
const AGENCY_MANAGER = 'AGENCY_MANAGER';
const ANONYMOUS = 'ANONYMOUS';
const APPROVEDADMINSTAFFL1 = 'APPROVEDADMINSTAFFL1';
const APPROVEDADMINSTAFFL2 = 'APPROVEDADMINSTAFFL2';
const ASSISTER = 'ASSISTER';
const ASSISTERENROLLMENTENTITY = 'ASSISTERENROLLMENTENTITY';
const ASSISTERENROLLMENTENTITYADMIN = 'ASSISTERENROLLMENTENTITYADMIN';
const ASSISTER_ADMIN = 'ASSISTER_ADMIN';
const BATCH_ADMIN = 'BATCH_ADMIN';
const BROKER = 'BROKER';
const BROKER_ADMIN = 'BROKER_ADMIN';
const CALHEERSADMINISTRATOR = 'CALHEERSADMINISTRATOR';
const CSR = 'CSR';
const CSR_GROUP = 'CSR_GROUP';
const EMPLOYEE = 'EMPLOYEE';
const EMPLOYER = 'EMPLOYER';
const EMPLOYERS = 'EMPLOYERS';
const EMPLOYER_ADMIN = 'EMPLOYER_ADMIN';
const ENTITY_MANAGER = 'ENTITY_MANAGER';
const EXTERNAL_ASSISTER = 'EXTERNAL_ASSISTER';
const INDIVIDUAL = 'INDIVIDUAL';
const ISSUER = 'ISSUER';
const ISSUER_ADMIN = 'ISSUER_ADMIN';
const ISSUER_ENROLLMENT_REPRESENTATIVE = 'ISSUER_ENROLLMENT_REPRESENTATIVE';
const ISSUER_REPRESENTATIVE = 'ISSUER_REPRESENTATIVE';
const L0_READONLY = 'L0_READONLY';
const L1_CSR = 'L1_CSR';
const L2_CSR = 'L2_CSR';
const OPERATIONS = 'OPERATIONS';
const PLAN_ADMIN = 'PLAN_ADMIN';
const SUPERVISOR = 'SUPERVISOR';
const INDIVIDUAL_LITE = 'INDIVIDUAL_LITE';
const SECURITY = 'SECURITY';
const BA = 'BA';
const L4_CSR = 'L4_CSR';
const EXCHANGE_STAFF = 'EXCHANGE_STAFF';

export const USER_GROUP_ROLES = {
    REGULAR_USERS: 'REGULAR_USERS',
    SUPERUSERS: 'SUPERUSERS',
    AGENCYUSERS: 'AGENCYUSERS'
};

export const USER_ROLES = {
    [USER_GROUP_ROLES.REGULAR_USERS]: {
        BROKER,
        INDIVIDUAL
    },
    [USER_GROUP_ROLES.SUPERUSERS]: {
        ADMIN,
        L0_READONLY,
        L1_CSR,
        L2_CSR,
        SUPERVISOR
    },
    [USER_GROUP_ROLES.AGENCYUSERS]: {
        AGENCY_MANAGER,
        APPROVEDADMINSTAFFL1,
        APPROVEDADMINSTAFFL2,
        ASSISTER,
        ASSISTERENROLLMENTENTITY,
        BROKER,
        ISSUER_REPRESENTATIVE
    }
};



export const checkUserStatus = (groupRole, userRole) => {
    if(!Object.prototype.hasOwnProperty.call(USER_ROLES, groupRole)) {
        return false;
    } else {
        return Object.prototype.hasOwnProperty.call(USER_ROLES[groupRole], userRole);
    }
};

export const ALL_USER_ROLES = {
    ADMIN,
    AGENCY_MANAGER,
    APPROVEDADMINSTAFFL1,
    APPROVEDADMINSTAFFL2,
    ASSISTER,
    ASSISTERENROLLMENTENTITYADMIN,
    ASSISTERENROLLMENTENTITY,
    ASSISTER_ADMIN,
    BATCH_ADMIN,
    BROKER_ADMIN,
    BROKER,
    CALHEERSADMINISTRATOR,
    CSR,
    EMPLOYEE,
    EMPLOYER,
    EMPLOYER_ADMIN,
    EMPLOYERS,
    ENTITY_MANAGER,
    EXTERNAL_ASSISTER,
    INDIVIDUAL,
    ISSUER,
    ISSUER_ADMIN,
    ISSUER_ENROLLMENT_REPRESENTATIVE,
    ISSUER_REPRESENTATIVE,
    L0_READONLY,
    L1_CSR,
    L2_CSR,
    OPERATIONS,
    PLAN_ADMIN,
    SUPERVISOR,
    INDIVIDUAL_LITE,
    SECURITY,
    BA,
    L4_CSR,
    EXCHANGE_STAFF,
};

export const USER_GROUPS = {
    AGENCY_GROUP,
    CSR_GROUP,
    ADMIN
};

export const ANONYMOUS_USER = {
    ANONYMOUS
};